<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="批量申付"
    :visible.sync="dialogVisible"
    width="800px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <TabStep class="tabstep" :active="active"></TabStep>
      <el-form
        v-show="active === 1"
        ref="form"
        class="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <div class="row">
          <el-form-item label="供应商" prop="supplierId">
            <el-select
              v-model="form.supplierId"
              style="width: 320px"
              placeholder="请选择供应商"
              filterable
              :disabled="type === 10"
              @change="supplierChange"
            >
              <el-option
                v-for="item in supplierOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="期望支付日期" prop="expectedPaymentDate">
            <el-date-picker
              v-model="form.expectedPaymentDate"
              style="width: 320px"
              placeholder="请输入期望支付日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="供应商银行账号" prop="supplierBankAccountId">
            <div class="custom_supplier" @click="customSelect">
              <div v-if="!form.supplierBankAccountId" class="placeholder">请选择供应商银行账号</div>
              <div v-if="form.supplierBankAccountId" class="account_box">
                <div class="account-t">
                  <span :class="['account_mark', accountMark(selectAccount.bankName)]">{{ selectAccount.bankName }}</span>
                  <span class="account_no">{{ selectAccount.accountNumber }}</span>
                </div>
                <div class="account-b">{{ selectAccount.accountName }}</div>
              </div>
              <i :class="['el-icon-arrow-up', arrowDown && 'arrowDown']"></i>
            </div>
            <el-select
              ref="supplier"
              v-model="form.supplierBankAccountId"
              class="supplier"
              style="width: 320px;"
              placeholder="请选择供应商银行账号"
              @visible-change="(e) => {
                !e && (arrowDown = false)
              }"
            >
              <el-option
                v-for="item in bankAccountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="accountlist-item"
              >
                <div class="account_box">
                  <div class="account-t">
                    <span :class="['account_mark', accountMark(item.bankName)]">{{ item.bankName }}</span>
                    <span class="account_no">{{ item.accountNumber }}</span>
                  </div>
                  <div class="account-b">{{ item.accountName }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="form.type"
              disabled
              style="width: 320px"
              placeholder="请选择申付单类型"
            >
              <el-option :label="defrayType" :value="type"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="申付金额" prop="totalAmount">
            <el-input
              v-model="form.totalAmount"
              style="width: 320px"
              placeholder="请输入金额"
              disabled
            >
              <div slot="suffix" class="suffix">{{ form.currency }}</div>
            </el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="申付备注" prop="remark" style="width: 100%">
            <el-input
              v-model="form.remark"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 3 }"
              resize="none"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div v-show="active === 2" class="data">
        <BaseTable
          height="399"
          :tableData="tableData"
          :loading="loading"
          :isPager="false"
          :border="true"
        >
          <template #custom-total>
            <div class="custom-total">
              <span>条数合计：<span class="value">{{ tableData?.columns?.length }}</span></span>
              <span style="margin-left: 40px;">
                总金额合计： <span class="value">{{ sumPrice }}</span>
              </span>
            </div>
          </template>
        </BaseTable>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-if="active !== 1" class="ok flex_c_c" @click="last">上一步</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">
        {{ active === 1 ? "下一步" : "确定" }}
      </div>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const TabStep = () => import('@/components/base/TabStep')
import { getSupplierDropDownList, getSupplierBankAccount } from '@/api/system'
import { addDefray } from '@/api/fee'
export default {
  components: {
    BaseTable,
    TabStep
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectionItem: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      loading: false,
      form: {
        supplierId: '',
        expectedPaymentDate: '',
        supplierBankAccountId: '',
        type: 4,
        currency: 'USD',
        totalAmount: '',
        remark: ''
      },
      rules: {
        supplierId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        expectedPaymentDate: [
          { required: true, message: '请输入期望支付日期', trigger: 'blur' }
        ],
        supplierBankAccountId: [
          {
            required: true,
            message: '请选择供应商银行账号',
            trigger: 'change'
          }
        ]
      },
      active: 1,
      supplierOptions: [],
      bankAccountOptions: [],
      arrowDown: false,
      tableData: {
        fileds: [
          {
            filed: 'invoiceNumber',
            label: '发票号',
            width: '170px'
          },
          {
            filed: 'blNo',
            label: '单号',
            width: '170px'
          },
          {
            filed: 'supplierName',
            label: '供应商',
            width: '200px'
          },
          {
            filed: 'amount',
            label: '总金额',
            width: '120px'
          },
          {
            filed: 'currency',
            label: '币制',
            width: '100px'
          }
        ],
        columns: []
      }
    }
  },
  computed: {
    selectAccount() {
      return this.bankAccountOptions.filter(a => a.id === this.form.supplierBankAccountId)[0]
    },
    sumPrice() {
      let sum = 0
      this.tableData?.columns?.forEach(i => {
        sum += +i.amount
      })
      return `${sum.toFixed(2)} ${this.form.currency}`
    },
    defrayType() {
      const obj = {
        4: '索赔',
        10: '其它业务'
      }
      return obj[this.type]
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.reset()
        if (this.type === 10) {
          const supplierId = this.selectionItem[0].supplierId
          this.form.supplierId = supplierId
          this.supplierChange(supplierId)
        }
        this.getCommData()
        let totalAmount = 0
        this.selectionItem.forEach(a => {
          totalAmount += this.type === 4 ? a.claimAmount : a.payableAmount
        })
        this.form.totalAmount = totalAmount
        this.form.type = this.type
      }
    }
  },
  methods: {
    reset() {
      this.form = this.$options.data().form
      this.tableData.columns = []
      this.bankAccountOptions = []
      this.$refs['form']?.resetFields()
    },
    cancel() {
      this.$emit('cancel')
    },
    getCommData() {
      getSupplierDropDownList({}).then((res) => {
        if (res.success) {
          res.data &&
            (this.supplierOptions = res.data.map((a) => {
              return {
                label: `${a.code}-${a.wbName}-${a.name}`,
                value: a.id
              }
            }))
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    getCommBankAccount(v) {
      getSupplierBankAccount({ supplierId: v }).then((res) => {
        res &&
          (this.bankAccountOptions = res.map((a) => {
            return {
              ...a,
              label: a.accountNumber,
              value: a.id,
              currency: a.currency
            }
          }))
      })
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          if (this.active === 1) {
            const invoiceDetails = this.selectionItem.map(a => {
              return {
                invoiceNumber: this.type === 4 ? `SPFP${a.id}` : a.serviceNo,
                amount: this.type === 4 ? a.claimAmount : a.payableAmount,
                blNo: this.type === 4 ? a.trackNumber : a.serviceNo,
                supplierName: this.supplierOptions.find(
                  (a) => a.value === this.form.supplierId
                )?.label,
                currency: 'USD',
                dataId: a.id
              }
            })
            this.tableData.columns = invoiceDetails
            this.active = 2
          } else {
            this.loading = true
            const params = {
              ...this.form,
              invoiceDetails: this.tableData.columns
            }
            try {
              const result = await addDefray(params)
              this.loading = false
              if (result.success) {
                this.$emit('ok')
                this.$message.success(result.errorMessage)
              } else {
                this.$message.error(result.errorMessage)
              }
            } catch (error) {
              this.loading = false
              console.error(error)
            }
          }
        } else {
          return false
        }
      })
    },
    last() {
      this.active > 1 && (this.active = this.active - 1)
    },
    supplierChange(v) {
      this.form.supplierBankAccountId = ''
      this.form.currency = 'USD'
      this.getCommBankAccount(v)
    },
    customSelect() {
      this.arrowDown = !this.arrowDown
      this.$nextTick(() => {
        this.arrowDown && this.$refs.supplier.toggleMenu()
        !this.arrowDown && this.$refs.supplier.blur()
      })
    },
    accountMark(v) {
      const mark1 = ['中国银行', '招商银行', '工商银行', '中信银行']
      const mark2 = ['中国建设银行', '交通银行', '美国银行']
      const mark3 = ['农业银行']
      const mark4 = ['汇丰银行']
      const mark5 = ['花旗银行']
      if (mark1.includes(v)) {
        return 'account_mark1'
      }
      if (mark2.includes(v)) {
        return 'account_mark2'
      }
      if (mark3.includes(v)) {
        return 'account_mark3'
      }
      if (mark4.includes(v)) {
        return 'account_mark4'
      }
      if (mark5.includes(v)) {
        return 'account_mark5'
      }
      if (!(mark1.includes(v) && mark2.includes(v) && mark3.includes(v) && mark4.includes(v) && mark5.includes(v))) {
        return 'account_mark1'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: relative;
  width: calc(100% - 80px);
  margin: 0 auto;
  padding-top: 40px;
  box-sizing: border-box;
  .tabstep {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
  }
  .row {
    display: flex;
    justify-content: space-between;
  }
  .custom_supplier {
    position: absolute;
    display: flex;
    align-items: center;
    width: 320px;
    min-height: 60px;
    height: auto;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    background-color: #FFF;
    z-index: 1;
    cursor: pointer;
    padding: 0 15px;
    & .el-icon-arrow-up {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%) rotateZ(180deg);
      width: 14px;
      height: 14px;
      color: #C0C4CC;
      font-size: 14px;
      transition: transform .3s;
    }
    & .arrowDown {
      transform: translateY(-50%) rotateZ(0deg);
    }
    .placeholder {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #c0c4cc;
    }
  }
  .supplier {
    min-height: 60px;
    height: auto;
    /deep/ .el-input,
    /deep/ input {
      height: 100%;
    }
  }
  .suffix {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-right: 5px;
  }
  .data {
    border-radius: 4px;
    overflow: hidden;
    .icon {
      margin-right: 5px;
    }
    .custom-total {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      background: #f7f7f7;
      border: 1px solid #eeeeee;
      border-top: 0;
      padding-left: 17px;
      padding-right: 40px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      .value {
        font-weight: bold;
        color: #FE453D;
      }
    }
  }
}
/deep/ .el-table .error-row {
  background: rgba(254, 69, 61, 0.1);
  color: #fe453d;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
  }
  .ok {
    background:  rgb(18,88,188);
    color: #ffffff;
    margin-left: 20px;
  }
}
.account_box div {
  line-height: normal;
}
.account-b {
  font-size: 12px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 5px;
}
.account_mark {
  display: inline-block;
  width: auto;
  height: 20px;
  border-radius: 2px 2px 2px 2px;
  padding: 2px 6px;
  box-sizing: border-box;
  margin-right: 5px;
  font-size: 12px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
}
.account_mark1 {
  background: rgba(254, 69, 61, .1);
  color: #FE453D;
}
.account_mark2 {
  background: rgba(35, 149, 243, .1);
  color:  rgb(18,88,188);
}
.account_mark3 {
  background: rgba(53, 186, 131, .1);
  color: #35BA83;
}
.account_mark4 {
  background: rgba(255, 116, 68, .1);
  color: #FF7444;
}
.account_mark5 {
  background: rgba(157, 103, 254, .1);
  color: #9D67FE;
}
.accountlist-item {
  display: flex;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #EEEEEE;
  box-sizing: border-box;
}
</style>
